import EmptyView        from 'scripts/defa/basic/view-empty-view';
import NotificationView from 'scripts/defa/notifications/view-notification-view';
/**
 * defa.views.NotificationCollectionView
 * A collection view for Notificaitons.
 * @version 0.1
 */
import CollectionView   from 'scripts/poppet/collection-view';

const NotificationCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	//Unread is true if notifications in this collection are unread.
	unread: false,

	childView: NotificationView,
	emptyView: EmptyView,
	
	emptyViewOptions: {
		context: 'notifications',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Removes the selected model from the collection
	 * @void Is triggered when user deletes the notification
	 * */
	onChildviewDelete: function( childView ){
		this.collection.remove( childView.model );
		this.trigger('delete', childView.model);
	},

	/**
	 * Removes the selected model from the collection if needed :
	 * - If collection is unread notifications, and the notification is marked as read
	 * - If collection is read notifications, and the notification is marked as unread
	 *
	 * @void Is triggered when user marks notification as read
	 * */
	onChildviewRead: function(childView, read){
		this.trigger('read', childView.model, read);

		if( this.unread === read ) {
			this.collection.remove(childView.model);
		}
	},
	
	/**
	 * Removes the selected model from the collection and delete/reads the model depending on which view you're in.
	 * @void Is triggered when user swipes the notification
	 * !TODO: Improve the delete confirmation method and add translation
	 */
	onChildviewSlid: function ( childView ) {
		console.log( `slid out notification with id ${childView.model.get( 'id' )}` );
		if(this.unread){
			this.onChildviewRead(childView, true);
		}else{
			let result = confirm('Want to delete?');
			if (result) {
				this.onChildviewDelete(childView);
			}else{
				this.render(); // Doing this to revert the slid animation if the user decides not to delete. Should figure out a better way to do this.
			}
		}
	},
	
	onRemoveChild() {
		if(0 === this.collection.length) {
			this.trigger('is:empty');
		}
	},

	onAddChild() {
		if(1 === this.collection.length) {
			this.trigger('is:not:empty');
		}
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default NotificationCollectionView;